import React from "react";
import { applyMiddleware, compose, createStore, } from 'redux';
import ReactDOM from "react-dom";
import thunk from 'redux-thunk'
import { Provider } from 'react-redux';

import App from "./App";
import { Auth0Provider } from "./react-auth0-spa";
import rootReducer from './reducer';
import * as serviceWorker from "./serviceWorker";
import history from "./utils/history";

import 'bootstrap/dist/css/bootstrap.min.css';
import "./index.scss";

const onRedirectCallback = appState => {
  history.push(
    appState && appState.targetUrl
      ? appState.targetUrl
      : window.location.pathname
  );
};

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
const store = createStore(
  rootReducer,
  composeEnhancers(
    applyMiddleware(thunk),
  )
);
// TO DO: Move Auth0Provider into Redux flow
ReactDOM.render(
  <Provider store={store}>
    <Auth0Provider
      domain={process.env.REACT_APP_AUTH0_DOMAIN}
      client_id={process.env.REACT_APP_AUTH0_CLIENT_ID}
      audience={process.env.REACT_APP_AUTH0_AUDIENCE}
      redirect_uri={window.location.origin}
      onRedirectCallback={onRedirectCallback}
    >
      <App />
    </Auth0Provider>
  </Provider>,
  document.getElementById("root")
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
